export default __webpack_public_path__ + "static/media/bitmart.eadee15d.svg";